import dayjs from "dayjs";
import { IClientLog } from "../models/configuration/pushback/IPushbackReport";
import { getClientLogSeverityColor } from "../utils/statusColors";
import { DTDataGridAlignment, DTDataGridColumnType, IDataColumn as DeprecatedIDataColumn } from "../models/IDataColumn";
import { IDataColumn } from "../components/ui/dataGrid";
import { IDataColumn as LegacyIDataColumn } from "../models/IDataColumn";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { DtExpandableText, DtViewableText } from "../components/ui/text";
export const clientLogs = (
): Array<IDataColumn> => {
    return [
        {
            name: "LogTime",
            fieldId: "LoggedTimestamp",
            datatype: 'text',
            sortable: true,
            renderCell: (item: IClientLog) => {
                return dayjs(item.LoggedTimestamp).format('MM/DD/YYYY hh:mm:ss A Z');
            },
            width: 25
        },
        {
            name: "Severity",
            fieldId: "SeverityLevel",
            datatype: 'text',
            sortable: true,
            foreColorFunction: (item: IClientLog) => getClientLogSeverityColor(item.SeverityLevel),
            width: 10
        },
        {
            name: "User",
            fieldId: "EncompassUser",
            datatype: 'text',
            sortable: true,
            width: 10
        },
        {
            name: "Message",
            fieldId: "Message",
            datatype: 'text',
            renderCell: (item: any) => <>
                <DtExpandableText
                    value={item?.Message}
                    showToggleLabel={false}
                /></>,
            sortable: true,
        }
    ];
};


export const clientLogsLegacy = (
): Array<LegacyIDataColumn> => {
    return [
        {
            name: "LogTime",
            fieldId: "LoggedTimestamp",
            datatype: DTDataGridColumnType.text,
            sortable: true,
            dataFunction: (item: IClientLog) => {
                return dayjs(item.LoggedTimestamp).format('MM/DD/YYYY hh:mm:ss A Z');
            }
        },
        {
            name: "Severity",
            fieldId: "SeverityLevel",
            datatype: DTDataGridColumnType.text,
            sortable: true,
            foreColorFunction: (item: IClientLog) => getClientLogSeverityColor(item.SeverityLevel)
        },
        {
            name: "User",
            fieldId: "EncompassUser",
            datatype: DTDataGridColumnType.text,
            sortable: true
        },
        {
            name: "Message",
            fieldId: "Message",
            datatype: DTDataGridColumnType.text,
            sortable: true,
        }
    ];
};

export const xPathDataColumns = (
    editItem: (e: any, item: any) => void,
    deleteItem: (e: any, item: any) => void
): Array<DeprecatedIDataColumn> => {
    return [
        {
            name: "",
            fieldId: "",
            datatype: DTDataGridColumnType.link,
            linkText: "Edit",
            foreColor: "blue",
            callbackFunction: editItem,
            alignment: DTDataGridAlignment.center
        },
        {
            name: "",
            fieldId: "",
            datatype: DTDataGridColumnType.link,
            linkText: "Delete",
            foreColor: "firebrick",
            callbackFunction: deleteItem,
        },
        {
            name: "Mapping Name",
            fieldId: "Name",
            datatype: DTDataGridColumnType.text,
        },
        {
            name: "Output Encompass Path",
            fieldId: "EncompassFieldId",
            datatype: DTDataGridColumnType.text,
        },
        {
            name: "Input XPath",
            fieldId: "Xpath",
            datatype: DTDataGridColumnType.text,
        }
    ];
};

export const xPathDataColumnsRef = (): Array<IDataColumn> => {
    return [
        {
            name: "Mapping Name",
            fieldId: "Name",
            datatype: 'text',
            renderCell: (item: any) => <>
                <DtExpandableText
                    value={item.Name}
                    showToggleLabel={false}
                /></>,
            width: 25
        },
        {
            name: "Output Encompass Path",
            fieldId: "EncompassFieldId",
            datatype: 'text',
            renderCell: (item: any) => <>
                <DtExpandableText
                    value={item.EncompassFieldId}
                    showToggleLabel={false}
                /></>,
            width: 30
        },
        {
            name: "Input XPath",
            fieldId: "Xpath",
            datatype: 'text',
            renderCell: (item: any) => <>
                <DtViewableText
                    value={item.Xpath}
                    modalTitle="Input XPath"
                /></>
        }
    ];
};